/** `PurchaseOrderController`'s HTTP surface (Stage 14, Phase 2, Step 2a). */
import { httpClient, unwrap, API_ENDPOINTS } from '@core/api';
import type { ApiSuccessResponse, PaginatedResult } from '@app-types/api.types';
import { getPaginatedList } from '@features/administration/services/_pagination';
import type { PurchaseOrderDto, PurchaseOrderLineDto, CreatePurchaseOrderInput, RejectPurchaseOrderInput } from '@nexao/contracts';

const BASE = API_ENDPOINTS.procurement.purchaseOrders;

export async function listPurchaseOrders(page = 1, limit = 25): Promise<PaginatedResult<PurchaseOrderDto>> {
  return getPaginatedList<PurchaseOrderDto>(BASE, { params: { page, limit } });
}

export async function getPurchaseOrderLines(poId: string): Promise<PurchaseOrderLineDto[]> {
  return unwrap(httpClient.get<ApiSuccessResponse<PurchaseOrderLineDto[]>>(`${BASE}/${poId}/lines`));
}

export async function createPurchaseOrder(input: CreatePurchaseOrderInput): Promise<PurchaseOrderDto> {
  return unwrap(httpClient.post<ApiSuccessResponse<PurchaseOrderDto>>(BASE, input));
}

export async function submitPurchaseOrder(id: string): Promise<PurchaseOrderDto> {
  return unwrap(httpClient.post<ApiSuccessResponse<PurchaseOrderDto>>(`${BASE}/${id}/submit`, {}));
}

export async function approvePurchaseOrder(id: string): Promise<PurchaseOrderDto> {
  return unwrap(httpClient.post<ApiSuccessResponse<PurchaseOrderDto>>(`${BASE}/${id}/approve`, {}));
}

export async function rejectPurchaseOrder(id: string, input: RejectPurchaseOrderInput): Promise<PurchaseOrderDto> {
  return unwrap(httpClient.post<ApiSuccessResponse<PurchaseOrderDto>>(`${BASE}/${id}/reject`, input));
}

export async function sendPurchaseOrderToVendor(id: string): Promise<PurchaseOrderDto> {
  return unwrap(httpClient.post<ApiSuccessResponse<PurchaseOrderDto>>(`${BASE}/${id}/send-to-vendor`, {}));
}

export async function closePurchaseOrder(id: string): Promise<PurchaseOrderDto> {
  return unwrap(httpClient.post<ApiSuccessResponse<PurchaseOrderDto>>(`${BASE}/${id}/close`, {}));
}

export async function cancelPurchaseOrder(id: string): Promise<PurchaseOrderDto> {
  return unwrap(httpClient.post<ApiSuccessResponse<PurchaseOrderDto>>(`${BASE}/${id}/cancel`, {}));
}
